import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { preferCleanPath } from './preferCleanPath';
import './index.css';

preferCleanPath();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
